import SystemBoundariesAndPoints from "./SystemBoundariesPoints";

export default SystemBoundariesAndPoints;
